import type { SimulationEvent } from '../../types/simulation.js';

export const sortEvents = (events: SimulationEvent[]): SimulationEvent[] => [...events].sort((a, b) => {
  const date = Date.parse(a.scheduledAt) - Date.parse(b.scheduledAt);
  return date !== 0 ? date : a.id.localeCompare(b.id);
});

export const getDueEvents = (events: SimulationEvent[], now: string): SimulationEvent[] => {
  const nowMs = Date.parse(now);
  return sortEvents(events.filter((event) => !event.processed && Date.parse(event.scheduledAt) <= nowMs));
};
